import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../modules/material/material-module.module';
import { SimpleModule } from '../simple/simple.module';
import { BigNumberComponent } from './big-number/big-number.component';
import { QuestionnaireAnswerComponent } from './questionnaire-answer/questionnaire-answer.component';
import { FilterTextComponent } from './table/components/filter-text/filter-text.component';
import { FilterComponent } from './table/components/filter/filter.component';
import { AccordeonHostDirective } from './table/directives/accordeon-host.directive';
import { TableComponent } from './table/table.component';
import { CustomTabComponent } from './custom-tab/custom-tab.component';
import { FilterBooleanComponent } from './table/components/filter-boolean/filter-boolean.component';
import { FilterDateComponent } from './table/components/filter-date/filter-date.component';
import { FilterNumberComponent } from './table/components/filter-number/filter-number.component';
import { FilterOptionsComponent } from './table/components/filter-options/filter-options.component';
import { AdvancedFiltersComponent } from './table/components/advanced-filters/advanced-filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { QuestionnaireAnswerPageComponent } from './questionnaire-answer/questionnaire-answer-page/questionnaire-answer-page.component';
import { FormFlowNavigationDirective } from './questionnaire-answer/directives/form-flow-navigation.directive';
import { TranslateModule } from '@ngx-translate/core';
import { DownloadService } from 'src/app/core/services/download.service';
import { ThemedPipe } from '../../pipes/themed.pipe';
import { EligibilityService } from './questionnaire-answer/core/eligibility.service';
import { QuestionWorldAddressComponent } from './question-world-address/question-world-address.component';
import { ProfileAddressInputComponent } from './profile-address-input/profile-address-input.component';

@NgModule({
  declarations: [
    TableComponent,
    AccordeonHostDirective,
    BigNumberComponent,
    FilterComponent,
    FilterTextComponent,
    FilterBooleanComponent,
    FilterDateComponent,
    FilterNumberComponent,
    FilterOptionsComponent,
    AdvancedFiltersComponent,
    QuestionnaireAnswerComponent,
    QuestionnaireAnswerPageComponent,
    FormFlowNavigationDirective,
    CustomTabComponent,
    ProfileAddressInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    SimpleModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    ThemedPipe,
    QuestionWorldAddressComponent,
  ],
  exports: [
    TableComponent,

    BigNumberComponent,
    QuestionnaireAnswerComponent,
    CustomTabComponent,
    ProfileAddressInputComponent,
  ],
  providers: [DownloadService, EligibilityService],
})
export class SmartModule {}
